//theme is not supported in gantt chart hence not using theme object for styling.
const styles = (theme) => ({
  popupContainer: {
    zIndex: 1,
    margin: 0,
    padding: 12,
    minWidth: 32,
    boxSizing: "border-box",
    whiteSpace: "pre-line",
    background: theme.ModalBGColor,
  },
  additionalStopsRowContainer: {
    display: "flex",
    flexDirection: "column",
    minWidth: 36,
    padding: 10,
    background: theme.ModalBGColor,
  },
  headerRowContainer: { width: 160 },
  headerRowWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between'
  },
  unarriveIcon: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 16
  },
  violation: {
    color: "#FA5C64",
  },
  headerRowValue: {
    fontWeight: 700,
    fontSize: 12,
    textTransform: "uppercase",
    color: theme.TextColor,
    lineHeight: 1,
    marginTop: 5,
    maxWidth:"none",
  },
  statusValue: {
    fontWeight: 600,
    fontSize: 12,
    textTransform: "uppercase",
    maxWidth:120
  },
  delayNameRow: {
    display: 'flex' ,
    alignItems: 'center',
    color: theme.violationColor,
    '& svg': {
      width: '14px !important',
      height: '14px !important',
      minWidth: 14,
      minHeight: 14,
      flexShrink: 0,
      display: 'block',
    }
  },

  delayNameValue: {
    textTransform: 'uppercase',
    color: theme.violationColor,
    fontSize: theme.dispatchCardTextFontSize,
    fontWeight: 600,
    marginLeft: 4,
  },
  noViolation: {
    color: "#05A792",
  },
  multipleColumnRowContainer: {
    display: "flex",
    minWidth: 140,
  },
  stopDelaysContainer: {
    flexDirection: 'column'
  },
  rowContainerRight : {
    marginLeft : 8
  },
  headerLabel : {
    textTransform: "uppercase",
  },
  proNumberValue: {
    maxWidth : 170,
    wordWrap: 'break-word',
    lineHeight: 1.2,
  },
  hyperlink: {
    cursor: 'pointer',
    textDecoration: 'underline'
  },
  completedStopTime: {
    maxWidth: 130,
    textTransform: "unset"
  },
  completedStopTimeHeader: {
    minWidth: 120
  },
  cancelDispatchHeaderLabel:{
    color:'#FA5C64'
  },
  driverAdditionalStop: {
    background: theme.ModalBGColor,
    paddingBottom: 4
  }
});

export default styles;
